import { render, staticRenderFns } from "./ForgotPasswordCard.vue?vue&type=template&id=4ea55dae&"
import script from "./ForgotPasswordCard.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports